/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendD4TimeseriesResponseDto } from '../models/backend-d-4-timeseries-response-dto';
import { getTimeseriesEndpointDashboardsD4TimeseriesGet } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-4-timeseries-get';
import { GetTimeseriesEndpointDashboardsD4TimeseriesGet$Params } from '../fn/dashboards/get-timeseries-endpoint-dashboards-d-4-timeseries-get';

@Injectable({ providedIn: 'root' })
export class BackendApiD4Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTimeseriesEndpointDashboardsD4TimeseriesGet()` */
  static readonly GetTimeseriesEndpointDashboardsD4TimeseriesGetPath = '/dashboards/d4/timeseries';

  /**
   * D4: 14 финансовых коэффициентов помесячно/погодно.
   *
   * Возвращает ВСЕ 14 коэффициентов одним пакетом (как Django UI). Фронт сам решает, что отрисовать как gauge, что линиями, что таблицей. Для granularity=year берётся последнее значение в каждом году (LAST), идентично Django `data_formatter(period='year', summarize=False)`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTimeseriesEndpointDashboardsD4TimeseriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD4TimeseriesGet$Response(
    params: GetTimeseriesEndpointDashboardsD4TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendD4TimeseriesResponseDto>> {
    return getTimeseriesEndpointDashboardsD4TimeseriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D4: 14 финансовых коэффициентов помесячно/погодно.
   *
   * Возвращает ВСЕ 14 коэффициентов одним пакетом (как Django UI). Фронт сам решает, что отрисовать как gauge, что линиями, что таблицей. Для granularity=year берётся последнее значение в каждом году (LAST), идентично Django `data_formatter(period='year', summarize=False)`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTimeseriesEndpointDashboardsD4TimeseriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTimeseriesEndpointDashboardsD4TimeseriesGet(
    params: GetTimeseriesEndpointDashboardsD4TimeseriesGet$Params,
    context?: HttpContext,
  ): Observable<BackendD4TimeseriesResponseDto> {
    return this.getTimeseriesEndpointDashboardsD4TimeseriesGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendD4TimeseriesResponseDto>): BackendD4TimeseriesResponseDto => r.body),
    );
  }
}
